module.exports = __webpack_public_path__ + "static/media/logo_turismo_responsavel.6b99d981.png";